
// 教学科研
let jxkyNavDic =
  [
    {
      name: "研究生教育",
      path: "/jxky/yanjiusheng",
    },
    {
      name: "毕业后医学教育",
      path: "/jxky/byhyxjy",
    },
    {
      name: "学术交流",
      path: "/jxky/xueshu",
    },

    {
      name: "承办杂志",
      path: "/jxky/zazhi",
    },
    {
      name: "科技创新平台",
      path: "/jxky/zdsys",
    },
    {
      name: "伦理委员会",
      path: "/jxky/llwyh",
    },
    {
      name: "药物临床试验机构",
      path: "/jxky/ywlcsyjg",
    }
  ]


export {
  jxkyNavDic
};
